import {
  useDarkMode as useSharedDarkMode,
  useResolvedTheme as useSharedResolvedTheme,
  useThemeMode as useSharedThemeMode,
  type ThemeMode,
} from "@scribenote/utils";

const STORAGE_KEY = "dark-mode-enabled";

export type { ThemeMode };

export function useDarkMode() {
  return useSharedDarkMode(STORAGE_KEY);
}

export function useThemeMode() {
  return useSharedThemeMode(STORAGE_KEY);
}

export function useResolvedTheme() {
  return useSharedResolvedTheme(STORAGE_KEY);
}
